<ng-container *ngIf="!isLoading; else loadingTemplate">

  <div class="page" style="height: 100%">
    <header>
      <div class="title">
        <h1>Company Management</h1>
        <p>Manage registered companies and their data</p>
      </div>

      <button class="btn-primary" (click)="openCreateCompanyDialog()">
        <span class="icon">＋</span>
        Add Company
      </button>
    </header>

    <div class="controls">
      <div class="search">
        <span class="icon">🔎</span>
        <input
          type="text"
          placeholder="Search by company name..."
          [ngModel]="searchTerm()"
          (ngModelChange)="searchTerm.set($event); page.set(1)"
        />
      </div>

      <label class="toggle">
        <input
          type="checkbox"
          [checked]="withJobOfferOnly()"
          (change)="withJobOfferOnly.set($event.target.checked); page.set(1)"
        />
        <span class="slider"></span>
        <span class="label">With job offer</span>
      </label>

      <div class="select">
        <span>Country</span>
        <select
          [ngModel]="selectedCountry()"
          (ngModelChange)="selectedCountry.set($event); page.set(1)"
        >
          <option value="">All</option>
          <option *ngFor="let c of countries()" [value]="c">{{ c }}</option>
        </select>
      </div>

      <div class="select">
        <span>Sort By</span>
        <select
          [ngModel]="sortBy()"
          (ngModelChange)="sortBy.set($event)"
        >
          <option value="recent">Recently Registered</option>
          <option value="name">Name (A–Z)</option>
          <option value="jobOffers">Job offers (High→Low)</option>
        </select>
      </div>
    </div>


    <div class="chips-row">
      <button
        class="chip"
        [class.active]="selectedIndustries().size === 0"
        (click)="resetIndustries()"
      >
        All industry
      </button>
      <button
        class="chip"
        *ngFor="let i of industries()"
        [class.active]="selectedIndustries().has(i)"
        (click)="toggleIndustry(i)"
      >
        {{ i }}
      </button>

      <button class="link" (click)="clearFilters()">Reset filters</button>
    </div>

    <div class="table">
      <div class="row head">
        <div class="col company">Company</div>
        <div class="col reg">Registration Date</div>
        <div class="col industry">Industry</div>
        <div class="col addr">Address</div>
        <div class="col offers">Job offer</div>
        <div class="col actions"></div>
      </div>

      <div class="row" *ngFor="let c of paginatedCompanies(); let i = index">
        <div class="col company">
          <img class="logo" [src]="companyLogo(c)" alt=""/>
          <div class="info">
            <div class="name">
              <a (click)="viewCompany(c.id)">{{ c.name  }}</a>
            </div>
            <div class="meta">
              <span class="email" *ngIf="c.partnerEmail">{{ c.partnerEmail }}</span>
              <span class="website" *ngIf="c.website">• {{ c.website }}</span>
            </div>
          </div>
        </div>

        <div class="col reg">
          {{ registeredAt(c) }}
        </div>

        <div class="col industry">
          <span class="badge">{{ c.industry || '—' }}</span>
        </div>

        <div class="col addr">
          {{ addressOf(c) }}
        </div>

        <div class="col offers">
        <span [class.no]="(c.jobOffersCount ?? 0) === 0">
          {{ jobOfferSummary(c) }}
        </span>
        </div>



        <div class="col actions">
          <button class="view" title="View profile" (click)="viewCompany(c.id)">👁</button>

          <div class="menu-wrap" [class.open]="openMenuIndex() === i">
            <button class="kebab" (click)="openMenuIndex.set(openMenuIndex() === i ? null : i)">⋮</button>

            <div class="menu" *ngIf="openMenuIndex() === i">
              <button (click)="editCompany(c); openMenuIndex.set(null)">✏️ Edit Company</button>
              <button class="danger" (click)="archiveCompany(c); openMenuIndex.set(null)">🗄 Archive Company</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
    <span>
      Showing
      {{ (page() - 1) * pageSize() + 1 }}
      –
      {{ Math.min(page() * pageSize(), filteredCompanies().length) }}
      of
      {{ filteredCompanies().length }}
      companies
    </span>

      <div class="pager">
        <button (click)="prevPage()" [disabled]="page() === 1">Previous</button>
        <button (click)="nextPage()" [disabled]="page() * pageSize() >= filteredCompanies().length">Next</button>
      </div>
    </div>

  </div>
</ng-container>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
